import { render, staticRenderFns } from "./FileMimeType.vue?vue&type=template&id=a5701332&scoped=true&"
import script from "./FileMimeType.vue?vue&type=script&lang=js&"
export * from "./FileMimeType.vue?vue&type=script&lang=js&"
import style0 from "./FileMimeType.vue?vue&type=style&index=0&id=a5701332&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5701332",
  null
  
)

export default component.exports